import LeadFormListener from "./custom/form/LeadFormListener";
import MapListener from "./custom/MapListener";
import GLightbox from 'glightbox';
import Swiper, {Keyboard, Navigation} from "swiper";
import 'swiper/css';

const leadFormListener = new LeadFormListener();
const mapListener = new MapListener();

document.addEventListener("DOMContentLoaded", function(event) {
    const lightbox = GLightbox({
        touchNavigation: true,
        autoplayVideos: true,
        selector: '.wp-block-gallery figure a'
    });

    const lightboxSingle = GLightbox({
        touchNavigation: true,
        autoplayVideos: true,
        selector: '.single-lightbox a'
    });


    const swiper = new Swiper('.swiper', {
        direction: 'vertical',
        loop: false,
        navigation: {
            nextEl: '.swiper-button-down',
            prevEl: '.swiper-button-up',
        },
        modules: [Navigation, Keyboard],
        keyboard: {
            enabled: true,
        },
    });

    const swiperLightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        selector: '.swiper-slide a'
    });
});